const if_custom_functions_config = [
  {
    selector: '#managecomics-content style',
    urlMatch: '/pages/managecomics/foc',
    fn: managecomics_foc
  },
  {
    selector: '#managecomics-content #mc-tab-subscriptions',
    urlMatch: '/pages/managecomics/my_subscriptions',
    fn: managecomics_subscriptions
  },
  {
    selector: '#ProductThumbs.product-single__thumbnails.flickity-enabled.is-draggable',
    urlMatch: '/products/',
    fn: match_product_carousel_thumbnails_to_dropdown
  }
  // Add more configs as needed
];

(function() {
  const intervalMs = 200;
  const timeoutMs = 10000;
  let waited = 0;
  let config = if_custom_functions_config.slice();

  const interval = setInterval(function() {
    config = config.filter(function(cfg) {
      let urlOk = true;
      if (cfg.urlMatch) {
        if (typeof cfg.urlMatch === 'string') {
          urlOk = window.location.href.includes(cfg.urlMatch);
        } else if (cfg.urlMatch instanceof RegExp) {
          urlOk = cfg.urlMatch.test(window.location.href);
        }
      }
      if (!urlOk) return true;

      const el = document.querySelector(cfg.selector);
      if (el) {
        try {
          cfg.fn(el);
        } catch(e) {
          // Optionally log or handle error
        }
        return false;
      }
      return true;
    });

    if (config.length === 0) {
      clearInterval(interval);
    }

    waited += intervalMs;
    if (waited >= timeoutMs) {
      clearInterval(interval);
    }
  }, intervalMs);
})();


function managecomics_subscriptions() {
  console.log('Manage Comics subscriptions loaded');
  const $mc = document.querySelector('#managecomics-content');
  // Add more logic as needed
}


function managecomics_foc() {
  console.log('Manage Comics FOC loaded!');
  const $mc = document.querySelector('#managecomics-content');
  if ($mc) {
    mc_foc_center_pagination($mc);
    mc_foc_hijack_pagination2($mc);

    // Observe #mc-content for any changes
    const mcContent = document.querySelector('#mc-content');
    if (mcContent) {
      let observer = null; // must be accessible for disconnect/reconnect

      const observerCallback = (mutationsList) => {
        // Stop observing to avoid infinite loop
        observer.disconnect();

        console.log('#mc-content changed');

        // Your function that might trigger more mutations
        mc_foc_center_pagination($mc);

        // Start observing again
        observer.observe(mcContent, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true
        });
      };

      observer = new MutationObserver(observerCallback);

      observer.observe(mcContent, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
    }
  }
}


function mc_foc_center_pagination($mc) {
  const pag = $mc.querySelector('.mc-pagination');
  if (pag && pag.parentElement) {
    pag.parentElement.classList.add('if-center-mc-pagination');
  }
}


// This version is slower since it reloads the whole page but is less convoluted
function mc_foc_hijack_pagination1($mc) {
  const links = $mc.querySelectorAll('.mc-pagination a:not(.active)');
  
  links.forEach(link => {
    const onclick = link.getAttribute('onclick');
    let url = null;
    if (onclick) {
      const match = onclick.match(/'([^']*)'/);
      url = match ? match[1] : null;
    }

    if (url) {
      url = removeQueryParam(url, 'o');
      link.removeAttribute('onclick');
      link.setAttribute('href', url);
    }
  });
}


// This version is slightly faster since it doesn't reload the whole page
let ogLoadPage;
function mc_foc_hijack_pagination2($mc) {
  if (!ogLoadPage) ogLoadPage = window.loadPage;

  window.loadPage = async function(url) {
    await newLoadPage(url);
    mc_foc_center_pagination($mc);
    history.pushState({}, '', removeQueryParam(url, 'o'));
    const section = document.querySelector('#managecomics-content .mc-section .mc-container');
    if (section) section.scrollIntoView({behavior:'instant', block:'start'});
  };
}


async function newLoadPage(url) {
  console.log('loadPage(', url, ')');
  
  try {
    const response = await fetch(fetchUrl, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({url: url})
    });

    if (response.status === 200) {
      const data = await response.json();
      updateContent(data);

      const anchor = document.getElementById('mc-top');
      if (anchor) {
        anchor.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
      return data;
    } else {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.error('Error loading page:', error);
    throw error;
  }
}


function removeQueryParam(url, param) {
  const [base, query] = url.split('?');
  if (!query) return url;

  const params = new URLSearchParams(query);
  params.delete(param);

  const newQuery = params.toString();
  return newQuery ? `${base}?${newQuery}` : base;
}


let suppressThumbnailObserver = false;
function match_product_carousel_thumbnails_to_dropdown() {
  // Set up a MutationObserver to watch for class changes on thumbnails
  const carousel = document.querySelector(
    "#ProductThumbs.product-single__thumbnails.flickity-enabled.is-draggable div.flickity-viewport div.flickity-slider"
  );
  if (!carousel) return;

  function isSelectedThumb(el) {
    return (
      el.classList.contains("product-single__thumbnail") &&
      el.classList.contains("is-selected") &&
      el.classList.contains("is-nav-selected")
    );
  }

  function onMutation(mutationsList) {
    if (suppressThumbnailObserver) return; // GUARD: do nothing if suppressed
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        const target = mutation.target;
        if (isSelectedThumb(target)) {
          suppressThumbnailObserver = true;
          selectVariantByMediaId(target.getAttribute("data-id"));
          // Allow UI update to finish, then re-enable observer
          setTimeout(() => { suppressThumbnailObserver = false; }, 200);
        }
      }
    }
  }

  const thumbs = carousel.querySelectorAll("div.product-single__thumbnail");
  thumbs.forEach((thumb) => {
    new MutationObserver(onMutation).observe(thumb, { attributes: true, attributeFilter: ["class"] });
  });

  thumbs.forEach((thumb) => {
    if (isSelectedThumb(thumb)) {
      selectVariantByMediaId(thumb.getAttribute("data-id"));
    }
  });
}

function selectVariantByMediaId(mediaId) {
  const map = window.productMediaVariantMap || [];
  const mapping = map.find(obj => obj.media_id === mediaId || obj.media_id == mediaId);
  if (!mapping) {
    console.log("No mapping found for media_id:", mediaId);
    return;
  }

  const optionValue = mapping.option_value;

  const currentValue = document.querySelector('div.product__selectors > div > div > popout-select > button > span').innerHTML;
  if (currentValue == optionValue) return;

  const popout = document.querySelector('div.product__selectors > div > div > popout-select');
  if (!popout) {
    console.log("Popout select not found");
    return;
  }

  selectPopoutOptionByValue(popout, optionValue);
}

function selectPopoutOptionByValue(popoutEl, value) {
  const option = popoutEl.querySelector(`[data-popout-option][data-value="${CSS.escape(value)}"]`);
  if (!option) {
    console.log("Option not found for value:", value);
    return;
  }

  // The theme expects a CustomEvent 'theme:popout:click'
  const event = new CustomEvent('theme:popout:click', {
    cancelable: true,
    bubbles: true,
    detail: { preventTrigger: false }
  });

  option.dispatchEvent(event);
}